class FormattingRuleEditorVM {
    companies: Array<Classes.Models.Company>;
    organizations: Array<Organization>;
    organizationId: number;
}